module.exports = __webpack_public_path__ + "static/ga_integration_6-0e1cb086e0cfc25037051a4d09a6f32e.png";